
export const analystSideMenuItem =
[{
    "userRole":"tech_analyst",
    "menuName":"Home",
    "isActive":"true",
    "path":"/tech-analyst",
    "imageUrl" : 'assets/images/sidebar-icons/home.svg'
  },
  {
    "userRole":"tech_analyst",
    "menuName":"My Reports",
    "isActive":"true",
    "path":"/tech-analyst/reports",
    "imageUrl" : 'assets/images/sidebar-icons/research.svg'
  },
  {
    "userRole":"tech_analyst",
    "menuName":"My Bookmarks",
    "isActive":"true",
    "path":"/tech-analyst/my-bookmarks",
    "imageUrl" : 'assets/images/sidebar-icons/bookmark.svg'
  },
  {
    "userRole":"tech_analyst",
    "menuName":"My Connections",
    "isActive":"true",
    "path":"/tech-analyst/my-connections",
    "imageUrl" : 'assets/images/sidebar-icons/connections.svg'
  },
  {
    "userRole":"tech_analyst",
    "menuName":"My Social",
    "isActive":"true",
    "path":"/tech-analyst/social-feeds",
    "imageUrl" : 'assets/images/sidebar-icons/social.svg'
  },
  {
    "userRole":"tech_analyst",
    "menuName":"Messages",
    "isActive":"true",
    "path":"/tech-analyst/messages",
    "imageUrl" : 'assets/images/sidebar-icons/message.svg'
  },
  {
    "userRole":"tech_analyst",
    "menuName":"My Meetings",
    "isActive":"true",
    "path":"/tech-analyst/my-meetings",
    "imageUrl" : 'assets/images/sidebar-icons/meetings.svg'
  },
  {
    "userRole":"tech_analyst",
    "menuName":"Transactions",
    "isActive":"true",
    "path":"/tech-analyst/transactions",
    "imageUrl" : 'assets/images/sidebar-icons/transactions.svg'
  }
  // {
  //   "userRole":"tech_analyst",
  //   "menuName":"Revenue",
  //   "isActive":"true",
  //   "path":"/tech-analyst/revenue",
  //   "imageUrl" : 'assets/images/sidebar-icons/revenue.svg'
  // },
  // {
  //   "userRole":"tech_analyst",
  //   "menuName":"Notifications",
  //   "isActive":"true",
  //   "path":"/tech-analyst/notifications",
  //   "imageUrl" : 'assets/images/sidebar-icons/notifications.svg'
  // }
  ];




// WEBPACK FOOTER //
// ./src/app/shared/constants/tech-analyst-menu.ts